export const requestDropdown = [
  'Tenant Request - Walk in',
  'Tenant Request - Call',
  'Tenant Request - Email',
  'Tenant Request - Other',
  'Kiosk Request',
  'Maintenance',
  'Routine',
  'Portal Request - Maintenance',
  'Portal Request - Other',
  'Preventative Maintenance',
  'Inspection',
];
